module.exports = __webpack_public_path__ + "static/media/i8-2-hand.b3783469.png";